import { useEffect, useRef, useState } from 'react';
import type { ReactElement } from 'react';
import { ComponentRegistry } from './ComponentRegistry';
import { loginWithPasskey, passkeyError, supportsPasskeys } from './passkeys';
import styles from './passkeys.module.css';

export function PasskeyLogin({ onSuccess }: { onSuccess: () => void }): ReactElement {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const active = useRef(true);
  useEffect(() => { active.current = true; return () => { active.current = false; }; }, []);
  async function login() {
    if (busy) return;
    setBusy(true); setError('');
    try { await loginWithPasskey(); if (active.current) onSuccess(); }
    catch (failure) { if (active.current) setError(passkeyError(failure)); }
    finally { if (active.current) setBusy(false); }
  }
  return <ComponentRegistry id="admin.passkeyLogin" className={styles.login}>
    <button type="button" disabled={busy || !supportsPasskeys()} onClick={() => void login()}>{busy ? '正在验证…' : '使用 Passkey 登录'}</button>
    {!supportsPasskeys() && <p role="status">此浏览器暂不支持通行密钥，请使用密码登录。</p>}
    {error && <p role="alert">{error}</p>}
  </ComponentRegistry>;
}
